import React, { useState } from "react";
import { useDispatch } from "react-redux";
import "./style.css";
import imageCompression from "browser-image-compression";
import OpacityLoading from "../loader/OpacityLoading";
import { uploadPhotos } from "../../../store/reducers/photosReducer";
import { Button, PopupForm } from "../Style";
import { editDetails } from "../../../store/reducers/authReducer";
import { toast } from "react-toastify";
const EditPics = (props) => {
  const dispatch = useDispatch();
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);

  function mimeToExtension(mimeType) {
    const map = {
      "image/jpeg": ".jpeg",
      "image/png": ".png",
      "image/gif": ".gif",
      "image/webp": ".webp",
      "image/jpg": ".jpg", // לעיתים mimetype יהיה כזה
    };
    return map[mimeType] || "";
  }

  async function postImage(image) {
    const rnd = Math.floor(Math.random() * 899999) + 100000;

    image = new File([image], rnd, {
      type: image.type,
    });
    const formData = new FormData();
    formData.append("image", image);
    setLoading(true);
    dispatch(uploadPhotos(formData)).then((data) => {
      if (`${image.name}${mimeToExtension(image.type)}` === data)
        dispatch(editDetails({ [props.kind]: data })).then((res) => {
          if (!res.payload?.error) {
            toast.success("התמונה עלתה בהצלחה!");
            props.init();
          } else toast.error(res.payload?.error);
        });
      else toast.error("הפעולה כשלה, נסה/י שנית או פנה/י לתמיכה");
    });
    setLoading(false);
  }

  const submit = async (event) => {
    event.preventDefault();
    await postImage(file);
  };

  const fileSelected = async (event) => {
    let imageFile = event.target.files[0];
    if (!imageFile) return;

    // GIF מונפש / SVG — לא ממירים ל-WebP כאן (איכות/תאימות)
    if (
      imageFile.type === "image/gif" ||
      imageFile.type === "image/svg+xml"
    ) {
      setFile(imageFile);
      return;
    }

    const options = {
      fileType: "image/webp",
      initialQuality: 0.92,
      alwaysKeepResolution: true,
      useWebWorker: true,
    };

    try {
      setLoading(true);
      const webpBlob = await imageCompression(imageFile, options);
      setLoading(false);
      const base =
        imageFile.name.replace(/\.[^/.]+$/, "").trim() || "image";
      imageFile = new File([webpBlob], `${base}.webp`, {
        type: "image/webp",
      });
    } catch (error) {
      setLoading(false);
      toast.error("לא ניתן לעבד את התמונה. נסו קובץ אחר או פנו לתמיכה.");
      return;
    }

    setFile(imageFile);
  };

  return (
    <PopupForm onClick={(e) => e.stopPropagation()}>
      <label
        htmlFor="file-upload"
        className="custom-file-upload"
        style={{ marginBottom: "5vh" }}
      >
        בחירת תמונה
      </label>
      <input
        id="file-upload"
        type="file"
        onChange={fileSelected}
        accept="image/*"
      />
      {file !== null && (
        <Button
          hoverBackground={"rgb(223, 223, 223)"}
          background={props.color}
          style={{
            borderRadius: "0px",
            width: "100%",
            padding: "13px",
            fontSize: "16px",
          }}
          onClick={(e) => submit(e)}
        >
          שמירה
        </Button>
      )}
      {loading && <OpacityLoading />}
    </PopupForm>
  );
};

export default EditPics;
